function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background-color: var(--dct--customized-colors-buttonsLinks, ",
        ");\n  border-radius: var(--dct--customized-radius-buttons, ",
        ");\n  border: none;\n  box-shadow: none;\n  color: ",
        ";\n  cursor: ",
        ";\n  display: block;\n  font-family: var(--dct--customized-fonts-primary, ",
        ");\n  font-size: 14px;\n  font-weight: bold;\n  height: ",
        ";\n  line-height: 1;\n  padding: 0 18px;\n  position: relative;\n  text-align: center;\n  text-transform: var(--dct--customized-textTransforms-buttons, ",
        ");\n  transition: background-color 86ms ease-out;\n  white-space: nowrap;\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  &:hover, &:active, &:focus {\n    background-color: var(--dct--customized-colors-buttonsLinks, ",
        ");\n    background-image: linear-gradient(rgba(0, 0, 0, 0.15) 0 0);\n    border: none;\n    box-shadow: none;\n    color: #fff;\n    outline: none;\n  }\n\n  &:focus:not(:hover) {\n    background-color: var(--dct--customized-colors-buttonsLinks, ",
        ");\n    background-image: none;\n  }\n\n  &.--is-disabled,\n  &:disabled,\n  &:disabled:hover {\n    background-color: #c6c4c4;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button as RebassButton } from '@dutchie/common/components/rebass-compat';
import { layout, space, fontSize, maxWidth } from 'styled-system';
import styled from 'styled-components';
import _ from 'lodash';
import { SmallLoader } from 'shared/components/loading';
import useStyledTheme from 'shared/hooks/use-styled-theme';
var LoaderContainer = styled.div(_templateObject());
var StyledButton = styled(function(_param) {
    var disabled = _param.disabled, props = _object_without_properties(_param, [
        "disabled"
    ]);
    return /*#__PURE__*/ _jsx(RebassButton, _object_spread({
        disabled: disabled
    }, _.omit(props, 'loading')));
})(_templateObject1(), function(param) {
    var theme = param.theme;
    var _theme_customized_colors, _theme_customized;
    var _theme_customized_colors_buttonsLinks;
    return (_theme_customized_colors_buttonsLinks = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_colors = _theme_customized.colors) === null || _theme_customized_colors === void 0 ? void 0 : _theme_customized_colors.buttonsLinks) !== null && _theme_customized_colors_buttonsLinks !== void 0 ? _theme_customized_colors_buttonsLinks : theme.colors.primaryBlue;
}, function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_buttons;
    return (_theme_customized_radius_buttons = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.buttons) !== null && _theme_customized_radius_buttons !== void 0 ? _theme_customized_radius_buttons : '33px';
}, function(props) {
    return props.loading ? 'transparent !important' : '#FFF';
}, function(props) {
    return props.loading || props.disabled ? 'not-allowed' : 'pointer';
}, function(param) {
    var theme = param.theme;
    var _theme_customized_fonts, _theme_customized;
    return theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_fonts = _theme_customized.fonts) === null || _theme_customized_fonts === void 0 ? void 0 : _theme_customized_fonts.primary;
}, function(props) {
    return props.height ? props.height : '40px';
}, function(param) {
    var theme = param.theme;
    var _theme_customized_textTransforms, _theme_customized;
    var _theme_customized_textTransforms_buttons;
    return (_theme_customized_textTransforms_buttons = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_textTransforms = _theme_customized.textTransforms) === null || _theme_customized_textTransforms === void 0 ? void 0 : _theme_customized_textTransforms.buttons) !== null && _theme_customized_textTransforms_buttons !== void 0 ? _theme_customized_textTransforms_buttons : 'uppercase';
}, function(props) {
    if (props.height === '33px') {
        return "line-height: 2.4;";
    }
    if (props.height === '27px') {
        return "line-height: 2;";
    }
    return "line-height: 2.5;";
}, layout, space, fontSize, maxWidth, function(param) {
    var theme = param.theme;
    var _theme_customized_colors, _theme_customized;
    var _theme_customized_colors_buttonsLinks;
    return (_theme_customized_colors_buttonsLinks = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_colors = _theme_customized.colors) === null || _theme_customized_colors === void 0 ? void 0 : _theme_customized_colors.buttonsLinks) !== null && _theme_customized_colors_buttonsLinks !== void 0 ? _theme_customized_colors_buttonsLinks : theme.colors.primaryBlue;
}, function(param) {
    var theme = param.theme;
    var _theme_customized_colors, _theme_customized;
    var _theme_customized_colors_buttonsLinks;
    return (_theme_customized_colors_buttonsLinks = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_colors = _theme_customized.colors) === null || _theme_customized_colors === void 0 ? void 0 : _theme_customized_colors.buttonsLinks) !== null && _theme_customized_colors_buttonsLinks !== void 0 ? _theme_customized_colors_buttonsLinks : theme.colors.primaryBlue;
}, function(props) {
    if (props.disabled) {
        return "\n        background-color: #9ea7ab;\n        color: #ffffff;\n        opacity: 1;\n      ";
    }
    if (props.disabled || props.loading) {
        return "\n        &:hover, &:active, &:focus {\n          background-color: #9ea7ab;\n          color: #ffffff;\n        }\n      ";
    }
    return '';
}, function(props) {
    var _props_theme_customized_colors, _props_theme_customized, _props_theme, _props_theme_customized_colors1, _props_theme_customized1, _props_theme1, _props_theme_customized_colors2, _props_theme_customized2, _props_theme2, _props_theme_customized_colors3, _props_theme_customized3, _props_theme3;
    var _props_theme_customized_colors_buttonsLinks, _props_theme_customized_colors_buttonsLinks1, _props_theme_customized_colors_buttonsLinks2, _props_theme_customized_colors_buttonsLinks3;
    return props.inverted && "\n    background-color: ".concat(props.backgroundColor || 'white', ";\n    background-image: none;\n    border: 2px solid var(--dct--customized-colors-buttonsLinks, ").concat((_props_theme_customized_colors_buttonsLinks = (_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_customized = _props_theme.customized) === null || _props_theme_customized === void 0 ? void 0 : (_props_theme_customized_colors = _props_theme_customized.colors) === null || _props_theme_customized_colors === void 0 ? void 0 : _props_theme_customized_colors.buttonsLinks) !== null && _props_theme_customized_colors_buttonsLinks !== void 0 ? _props_theme_customized_colors_buttonsLinks : props.theme.colors.primaryBlue, ");\n    color: ").concat(props.loading ? 'transparent' : "var(--dct--customized-colors-buttonsLinks, ".concat((_props_theme_customized_colors_buttonsLinks1 = (_props_theme1 = props.theme) === null || _props_theme1 === void 0 ? void 0 : (_props_theme_customized1 = _props_theme1.customized) === null || _props_theme_customized1 === void 0 ? void 0 : (_props_theme_customized_colors1 = _props_theme_customized1.colors) === null || _props_theme_customized_colors1 === void 0 ? void 0 : _props_theme_customized_colors1.buttonsLinks) !== null && _props_theme_customized_colors_buttonsLinks1 !== void 0 ? _props_theme_customized_colors_buttonsLinks1 : props.theme.colors.primaryBlue, ")"), ";\n    &:hover, &:active, &:focus {\n      background-color: #f2f2f2;\n      background-image: none;\n      border: 2px solid var(--dct--customized-colors-buttonsLinks, ").concat((_props_theme_customized_colors_buttonsLinks2 = (_props_theme2 = props.theme) === null || _props_theme2 === void 0 ? void 0 : (_props_theme_customized2 = _props_theme2.customized) === null || _props_theme_customized2 === void 0 ? void 0 : (_props_theme_customized_colors2 = _props_theme_customized2.colors) === null || _props_theme_customized_colors2 === void 0 ? void 0 : _props_theme_customized_colors2.buttonsLinks) !== null && _props_theme_customized_colors_buttonsLinks2 !== void 0 ? _props_theme_customized_colors_buttonsLinks2 : props.theme.colors.primaryBlue, ");\n      color: var(--dct--customized-colors-buttonsLinks, ").concat((_props_theme_customized_colors_buttonsLinks3 = (_props_theme3 = props.theme) === null || _props_theme3 === void 0 ? void 0 : (_props_theme_customized3 = _props_theme3.customized) === null || _props_theme_customized3 === void 0 ? void 0 : (_props_theme_customized_colors3 = _props_theme_customized3.colors) === null || _props_theme_customized_colors3 === void 0 ? void 0 : _props_theme_customized_colors3.buttonsLinks) !== null && _props_theme_customized_colors_buttonsLinks3 !== void 0 ? _props_theme_customized_colors_buttonsLinks3 : props.theme.colors.primaryBlue, ");\n    }\n    &:focus:not(:hover) {\n      background-color: #f2f2f2;\n      background-image: none;\n    }\n  ");
}, function(props) {
    return props.gray && "\n    background-color: #a3b2c1;\n    color: ".concat(props.loading ? 'transparent' : '#FFF', ";\n    &:hover, &:active {\n      background-color: #777f85;\n    }\n    &:focus:not(:hover),\n    &:disabled:hover {\n      background-color: #a3b2c1;\n    }\n    opacity: ").concat(props.disabled ? '0.5' : '1', ";\n  ");
}, function(props) {
    var _props_theme_customized_colors, _props_theme_customized, _props_theme, _props_theme_customized_colors1, _props_theme_customized1, _props_theme1;
    var _props_theme_customized_colors_buttonsLinks, _props_theme_customized_colors_buttonsLinks1;
    return props.link && "\n    background-color: #fff;\n    background-image: none;\n    color: ".concat(props.loading ? 'transparent' : "var(--dct--customized-colors-buttonsLinks, ".concat((_props_theme_customized_colors_buttonsLinks = (_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_customized = _props_theme.customized) === null || _props_theme_customized === void 0 ? void 0 : (_props_theme_customized_colors = _props_theme_customized.colors) === null || _props_theme_customized_colors === void 0 ? void 0 : _props_theme_customized_colors.buttonsLinks) !== null && _props_theme_customized_colors_buttonsLinks !== void 0 ? _props_theme_customized_colors_buttonsLinks : props.theme.colors.primaryBlue, ")"), ";\n    font-weight: normal;\n    text-transform: none;\n    &:hover, &:active {\n      color: var(--dct--customized-colors-buttonsLinks, ").concat((_props_theme_customized_colors_buttonsLinks1 = (_props_theme1 = props.theme) === null || _props_theme1 === void 0 ? void 0 : (_props_theme_customized1 = _props_theme1.customized) === null || _props_theme_customized1 === void 0 ? void 0 : (_props_theme_customized_colors1 = _props_theme_customized1.colors) === null || _props_theme_customized_colors1 === void 0 ? void 0 : _props_theme_customized_colors1.buttonsLinks) !== null && _props_theme_customized_colors_buttonsLinks1 !== void 0 ? _props_theme_customized_colors_buttonsLinks1 : props.theme.colors.primaryBlue, ");\n      background-color: #fff;\n      background-image: none;\n    }\n    &:focus {\n      background-color: #fff;\n      background-image: none;\n    }\n  ");
});
StyledButton.defaultProps = {
    theme: {
        colors: {
            primaryBlue: '#4597e0'
        }
    }
};
var Button = function(_param) {
    var _param_loading = _param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, children = _param.children, _param_inverted = _param.inverted, inverted = _param_inverted === void 0 ? false : _param_inverted, _param_link = _param.link, link = _param_link === void 0 ? false : _param_link, _param_onClick = _param.onClick, onClick = _param_onClick === void 0 ? _.noop : _param_onClick, props = _object_without_properties(_param, [
        "loading",
        "disabled",
        "children",
        "inverted",
        "link",
        "onClick"
    ]);
    var _theme_customized_colors, _theme_customized;
    var theme = useStyledTheme();
    var _theme_customized_colors_buttonsLinks;
    var spinnerColor = inverted ? (_theme_customized_colors_buttonsLinks = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_colors = _theme_customized.colors) === null || _theme_customized_colors === void 0 ? void 0 : _theme_customized_colors.buttonsLinks) !== null && _theme_customized_colors_buttonsLinks !== void 0 ? _theme_customized_colors_buttonsLinks : theme.colors.primaryBlue : '#fff';
    return /*#__PURE__*/ _jsxs(StyledButton, _object_spread_props(_object_spread({
        loading: loading,
        disabled: disabled || loading,
        inverted: inverted,
        link: link,
        onClick: disabled || loading ? _.noop : onClick
    }, props), {
        children: [
            children,
            loading && /*#__PURE__*/ _jsx(LoaderContainer, {
                children: /*#__PURE__*/ _jsx(SmallLoader, {
                    "aria-label": "Loading",
                    height: 20,
                    color: spinnerColor
                })
            })
        ]
    }));
};
export default Button;
